// SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>
//
// SPDX-License-Identifier: MPL-2.0

import i18next from "i18next";
import { writable } from "svelte/store";
import de from "../../public/locales/de/translation.json";
import en from "../../public/locales/en/translation.json";
import es from "../../public/locales/es/translation.json";

//store used for activtion/deactivation of UI Features
const featureStore = writable({
	chat: true,
	recherche: true,
	askTheText: false,
	summary: true,
});

//store used for recherche page
const rechercheStore = writable({
	sources: [],
	_currentlySelectedDBSources: [],
	answers: [],
	currentQuestion: "",
	llm: {},
	llm_selected_by_user: false,
});

//store used for 'onyl documents'-settings in recherche page
const documentStore = writable({
	sources: [],
	_currentlySelectedDBSources: [],
	answers: [],
	currentQuestion: "",
	llm: {},
	llm_selected_by_user: false,
});

//store used for summary page
const summaryStore = writable({
	result: null,
	file: null,
	text: null,
	rating: 0,
});

//seperated from recherche store -> able to reacte only to this property
const active_llms_recherche = writable({
	recherche: [],
});

const availableSourcesStore = writable({
	available_sources: [],
});

//store used for chat page
const chatStore = writable({
	messages: [],
	newMessage: "",
	lastUserMessage: "",
	llm: {},
	llm_selected_by_user: false,
});
//seperated from recherche store -> able to reacte only to this property
const active_llms_chat = writable({
	chat: [],
});

const releaseStore = writable({
	releases: [],
	currentVersion: null,
	currentNotes: null,
	currentReleaseDate: null,
});

const textStore = writable({
	texts: null,
});

const savedLanguage = localStorage.getItem("language") || "de"; // default language is german ♥

i18next.init({
	lng: savedLanguage,
	fallbackLng: "de",
	resources: {
		en: { translation: en },
		de: { translation: de },
		es: { translation: es },
	},
});

/**
 * A function to load texts from i18next into our textStore
 */
function loadUITextsFromI18n() {
	const currentTexts = i18next.getResourceBundle(
		i18next.language,
		"translation",
	);
	textStore.update(() => ({
		texts: currentTexts,
	}));
}

i18next.on("languageChanged", (lng) => {
	// When the language changes, reload the texts into our store
	loadUITextsFromI18n();
});

/**
 Load Current Version and release notes
 */
function loadReleaseDetails() {
	fetch("releaseDetails.json")
		.then((r) => r.json())
		.then((data) => {
			releaseStore.update(() => ({
				releases: data.releases,
				currentVersion: data.releases[0].version,
				currentNotes: data.releases[0].releaseNotes,
				currentReleaseDate: data.releases[0].releaseDate,
			}));
		});
}

/**
 Init LLM piplines for chat and get availalbe LLMs
 */

function get_llms_chat(endpoint = `${process.env.API_URL}/chat/llms`) {
	const url = endpoint;
	fetch(url, {
		method: "GET",
		headers: {
			"Content-type": "application/json",
		},
	})
		.then((response) => response.json())
		.then((response) => {
			active_llms_chat.update(() => ({ chat: response }));
		});
}

/**
 Init LLM piplines for rag and get availalbe LLMs
 */
function get_llms_recherche(endpoint = `${process.env.API_URL}/rag/llms`) {
	const url = endpoint;
	fetch(url, {
		method: "GET",
		headers: {
			"Content-type": "application/json",
		},
	})
		.then((response) => {
			return response.json();
		})
		.then((response) => {
			active_llms_recherche.update(() => ({ recherche: response }));
		});
}

/*
 *
 * Load available LLMs from server.
 */
function loadAvailableSources() {
	const API_URL = `${process.env.API_URL}/rag/sources`;

	fetch(API_URL)
		.then((response) => response.json())
		.then((sources) => {
			availableSourcesStore.update(() => ({
				available_sources: sources,
			}));
		});
}

//load release Notes from json file
loadReleaseDetails();

//load ui texts from json
loadUITextsFromI18n();

//init LLMs for chat and recherche
get_llms_recherche();
get_llms_chat();

//init WissensDB with available sources
loadAvailableSources();

// (re-)load active/available LLMs every 5 minutes
setInterval(get_llms_chat, 1000 * 60);

setInterval(get_llms_recherche, 1000 * 60);

export default {
	rechercheStore: rechercheStore,
	documentStore: documentStore,
	availableSourcesStore: availableSourcesStore,
	chatStore: chatStore,
	active_llms_recherche: active_llms_recherche,
	active_llms_chat: active_llms_chat,
	releaseStore: releaseStore,
	textStore: textStore,
	featureStore: featureStore,
	summaryStore: summaryStore,
};
